import { useState } from 'react';

/** Remount for an explicit viewing session, not for overlays or mirrored thread ids. */
export function useViewingSessionKey(path: string): { key: number; chatId: string } {
  const url = new URL(path, 'https://crowdex.invalid');
  const request =
    url.pathname === '/desktop' && url.searchParams.get('newSession') === 'true'
      ? JSON.stringify(
          [
            'panel',
            'artifactId',
            'artifactType',
            'artifactLocator',
            'workspaceId',
            'mode',
            'personalWorkspace',
          ].map((name) => url.searchParams.get(name)),
        )
      : null;
  const [state, setState] = useState(() => ({ request, key: 0, chatId: crypto.randomUUID() }));
  if (request !== state.request) {
    const next = {
      request,
      key: request === null ? state.key : state.key + 1,
      chatId: request === null ? state.chatId : crypto.randomUUID(),
    };
    setState(next);
    return next;
  }
  return state;
}
